import React from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Avatar, Box, Divider, Typography, Button } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import PaymentIcon from "@mui/icons-material/Payment";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import { CookieKey, deleteCookie } from "../../../../../hooks/useCookie";
import { accountService } from "./services";

interface Props {
  userData?: {
    first_name: string;
    last_name: string;
  };
}

export default function AccountMenu({ userData }: Props) {
  // States
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // Handlers
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    deleteCookie(CookieKey.JWT_TOKEN);
    deleteCookie(CookieKey.REFRESH_TOKEN);
    window.location.href = "/login";
  };

  const handleBilling = async () => {
    const billingData = await accountService.fetchBilling();
    window.location.replace(billingData.url);
  };

  const handleAccount = async () => {
    window.location.replace("/account");
  };

  const getUserDisplayName = () => {
    if (userData?.first_name && userData?.last_name) {
      return `${userData.first_name} ${userData.last_name}`;
    }
    if (userData?.first_name) {
      return userData.first_name;
    }
    return "User";
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        variant="outlined"
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "20px",
          padding: "8px 16px",
          textTransform: "none",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          color: "#23272E",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            borderColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
        startIcon={
          <Avatar
            sx={{
              width: 32,
              height: 32,
              fontSize: "14px",
            }}
          >
            <PersonIcon />
          </Avatar>
        }
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            marginLeft: "8px",
          }}
        >
          {getUserDisplayName()}
        </Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        slotProps={{
          paper: {
            style: {
              width: "240px",
            },
          },
        }}
      >
        <MenuItem onClick={handleAccount}>
          <ManageAccountsIcon sx={{ marginRight: "12px" }} />
          <Typography sx={{ fontSize: "14px" }}>Account</Typography>
        </MenuItem>
        <MenuItem onClick={handleBilling}>
          <PaymentIcon sx={{ marginRight: "12px" }} />
          <Typography sx={{ fontSize: "14px" }}>Billing</Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <LogoutIcon sx={{ marginRight: "12px" }} />
          <Typography sx={{ fontSize: "14px" }}>Logout</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
}
